import type { IconDefinition } from '../index.tsx';

export const iconBookmark: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconBookmark',
  icon: [16, 16, [], '', 'M2 0H14V16H12L8 12L4 16H2V0Z'],
};
